import { render, staticRenderFns } from "./outlayCoupon.vue?vue&type=template&id=48257c24&lang=pug&"
import script from "./outlayCoupon.vue?vue&type=script&lang=js&"
export * from "./outlayCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports